
// Card settings
export const CARD_TITLE_BELOW = 1;
export const CARD_TITLE_ABOVE = 2;
export const CARD_TITLE_ABOVE_INSIDE = 3;
export const CARD_TITLE_BELOW_INSIDE = 4;

export const CARD_BORDER_SOLID = 1;
export const CARD_BORDER_DASHED = 2;

export const CARD_BORDER_COLOR_DEFAULT = '#333';
export const CARD_BORDER_COLOR_ALERT = '#dc3545'; // red
export const CARD_BORDER_COLOR_WARN = '#ffc107'; // yellow
export const CARD_BORDER_COLOR_SUCCESS = '#28a745'; // green

export const CARD_SIZE_SMALL = 'small';
export const CARD_SIZE_MEDIUM = 'medium';
export const CARD_SIZE_LARGE = 'large';

// Row settings
export const ROW_SIZE_SMALL = 'small';
export const ROW_SIZE_MEDIUM = 'medium';
export const ROW_SIZE_LARGE = 'large';